let isMounted = true;
const controller = new AbortController();
const REGISTER_URL = "/clients";

export async function addClient(data, axiosPrivate) {
  console.log(data);
  try {
    const response = await axiosPrivate.post(
      REGISTER_URL,
      JSON.stringify(data),
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );
    // Optionally, you can handle success response here
    return response;
  } catch (err) {
    // Handle errors here
    console.error(err);
    return err;
  } finally {
    // Cleanup logic
    isMounted = false;
    controller.abort();
  }
}
